/** Height class names for editor scroller - keys match Dimensions from design system */
const heightKeys = [
  's0',
  's1',
  's2',
  's4',
  's6',
  's8',
  's12',
  's16',
  's20',
  's24',
  's32',
  's40',
  's48',
  's64',
  's80',
  's96',
  's120',
  's140',
  's200',
  's240',
  's300',
  's360',
  's400',
  's600',
]

export const styles = {
  height: Object.fromEntries(
    heightKeys.map((k) => [k, `TextEditor_editorScroller_${k}`])
  ) as Record<string, string>,
} as const
